export const ContentStatus = Object.freeze({
    UNAPPROVED : 0,
    APPROVED : 1,
    IN_REVIEW : 2,
    PENDING : 3,
    FLAGGED : 4,
    REMOVED : 5,
    DELETED : 6,
  });